export interface IFavourite {
  favid: string;
  name: string;
  createdBy?: string;
  created?: string;
}

export const mapFavourites = (res: any): IFavourite[] => {
  const list = res?.data?.favourites;
  if (!Array.isArray(list)) return [];

  return list
    .filter(fav => fav?.favid)
    .map(fav => ({
      favid: String(fav.favid),
      name: fav.name ? String(fav.name) : "Untitled",
      createdBy: fav.full_name ?? undefined,
      created: fav.created ?? undefined,
    }));
};
